export const CREATE_SETTLEMENT = "CREATE_SETTLEMENT";
export const FETCH_SETTLEMENTS = "FETCH_SETTLEMENTS";
export const FETCH_SETTLEMENT = "FETCH_SETTLEMENT";
export const EDIT_SETTLEMENT = "EDIT_SETTLEMENT";
export const CLEAR_SETTLEMENT = "CLEAR_SETTLEMENT";
